module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Sun-594d983421a147b5e82533dc4db67b43.svg";